module.exports = __webpack_public_path__ + "img/FeaturePic2.0ccf5880.png";